// extracted by mini-css-extract-plugin
export default {"container":"Main_container__o-LA5","text":"Main_text__2Vwsm","blue":"Main_blue__a-HFz","homeImg":"Main_homeImg__eGmnw","pulse":"Main_pulse__4IgKB"};